module.exports = __webpack_public_path__ + "img/Card long.21346050.png";